import * as React from 'react';
import { BrokenFlowModal as DefaultBrokenFlowModal } from '@edreamsodigeo/frontend-flights-results';
import { Show, useBrokenFlowModal } from '@edreamsodigeo/frontend-core';
import { ShellErrorTranslationsProvider } from './TranslationsProvider';
export const AppBrokenFlowModal = () => {
  const modalProps = useBrokenFlowModal();
  return /*#__PURE__*/React.createElement(ShellErrorTranslationsProvider, null, /*#__PURE__*/React.createElement(Show, {
    when: modalProps.isOpen
  }, /*#__PURE__*/React.createElement(DefaultBrokenFlowModal, modalProps)));
};